import { useTranslation } from 'react-i18next';
import { List, ListItem, Typography, ListItemIcon, ListItemText } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ResponsiveDialog from '../UI/Dialogs/ResponsiveDialog';

function WorktypeListDialog({ worktypes, open, onClose }) {
    const { t } = useTranslation('allBookings');

    return (
        <ResponsiveDialog title="" open={open} onClose={onClose}>
            <Typography variant="subtitle1">{t('calldelta.worktypeListDialog.description')}</Typography>
            <List>
                {worktypes &&
                    worktypes.map((worktype, i) => (
                        <ListItem key={i}>
                            <ListItemIcon>
                                <CircleIcon style={{ color: 'var(--primary)' }} />
                            </ListItemIcon>
                            <ListItemText primary={worktype} />
                        </ListItem>
                    ))}
            </List>
        </ResponsiveDialog>
    );
}

export default WorktypeListDialog;
